module.exports = __webpack_public_path__ + "static/images/txsp-bg.9d16a85.png";